(function () {
  "use strict";

  function initVariantSync(root) {
    var select = root.querySelector("[data-product-variant-select]");
    var priceNode = root.querySelector("[data-product-price]");
    var compareNode = root.querySelector("[data-product-compare-price]");
    var saveBadge = root.querySelector("[data-product-save-badge]");
    var addButton = root.querySelector("[data-add-to-cart]");
    if (!select) return;

    select.addEventListener("change", function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (addButton) {
        addButton.setAttribute("data-variant-id", option.value);
        addButton.disabled = option.disabled;
      }

      if (priceNode && option.getAttribute("data-price")) {
        priceNode.textContent = option.getAttribute("data-price");
      }

      if (compareNode) {
        var compare = option.getAttribute("data-compare-price") || "";
        compareNode.textContent = compare;
        compareNode.hidden = !compare;
      }

      if (saveBadge) {
        var save = option.getAttribute("data-save-percent") || "";
        if (save) {
          saveBadge.textContent = "SAVE " + save + "%";
          saveBadge.hidden = false;
        } else {
          saveBadge.hidden = true;
        }
      }
    });
  }

  function initVaultPage(root) {
    initVariantSync(root);
  }

  function initAll() {
    document.querySelectorAll("[data-product-vault]").forEach(function (root) {
      if (root.__productVaultInit) return;
      initVaultPage(root);
      root.__productVaultInit = true;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
